import { StrictMode } from "react";

import { createRoot } from "react-dom/client";

import { BrowserRouter } from "react-router-dom";

import { Provider } from "react-redux";

import "bootstrap/dist/css/bootstrap.min.css";

import "bootstrap/dist/js/bootstrap.bundle.min.js";

import "@kanakku/index.scss";

import "@/styles/billing-overrides.css";
import "@/styles/app.css";

import "@kanakku/style/css/iconsax.css";

import "@kanakku/style/css/feather.css";

import "@tabler/icons-webfont/dist/tabler-icons.min.css";

import "@fortawesome/fontawesome-free/css/fontawesome.min.css";

import "@fortawesome/fontawesome-free/css/all.min.css";

import store from "@kanakku/core/redux/store";

import { BillingProviders } from "./providers/BillingProviders";

import { AppErrorBoundary } from "./components/AppErrorBoundary";

import { AppRouter } from "./router/router";



createRoot(document.getElementById("root")!).render(

  <StrictMode>

    <BillingProviders>

      <Provider store={store}>

        <BrowserRouter>

          <AppErrorBoundary>

            <AppRouter />

          </AppErrorBoundary>

        </BrowserRouter>

      </Provider>

    </BillingProviders>

  </StrictMode>,

);


